import { Button, Icon, Input, Popover } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  couponClearMessage,
  validateCoupon,
  validateCouponReset
} from "../../redux/actions/generalActions";
import { setLoginError } from "../../redux/actions/betSlipActions";
import Alert from "./Alert";
import { SessionStorage } from "../../helpers";

export class CheckCoupon extends Component {
  state = {
    couponCode: undefined,
  };
  componentDidMount(){
    this.props.validateCouponReset();
  }
  validateCouponCode = () => {
    let request = {
      couponCode: this.state.couponCode || SessionStorage.couponCode,
    };
    this.props.validateCoupon(request);
  };
  addLineSpace = (data) => {
    return (
      data &&
      data.split("/n").map(function(item) {
        return (
          <span>
            {item}
            <br />
          </span>
        );
      })
    );
  };
  render() {
    const {
      signedIn,
      validateCouponMessage,
      validateCouponError,
      validateCouponLoading,
      couponName,
    } = this.props;
    return (
      <div className="validate-coupon-container" style={{ padding: "5px" }}>
        <div className="check-coupon-row">
          <div className="code">
            <Input
              id="couponCode"
              placeholder="Enter Here"
              onChange={(e) => {
                this.setState({
                  couponCode: e.target.value,
                });
                SessionStorage.couponCode = e.target.value;
                couponClearMessage();
                setLoginError(false);
              }}
            />
          </div>
          <div className="check-button-container">
            <Button
              loading={validateCouponLoading}
              disabled={validateCouponLoading}
              type="primary"
              className="bet-slip-buttons"
              // className="success"
              onClick={this.validateCouponCode}
            >
              Check
            </Button>
          </div>
        </div>

        {validateCouponError && (
          <div className="notice">
            <Alert message={validateCouponError} type="error" />
          </div>
        )}
        {validateCouponMessage && (
          <div className="notice">
            <Popover
              overlayClassName="more-info-popover"
              placement="bottom"
              getPopupContainer={(trigger) => trigger.parentNode}
              arrowPointAtCenter
              content={
                <div>
                  {" "}
                  {validateCouponMessage &&
                    this.addLineSpace(validateCouponMessage)}{" "}
                </div>
              }
              trigger="click"
            >
              <div>
                <Alert
                  message={couponName}
                  type="info"
                  icon={<Icon type="info" />}
                />
              </div>
            </Popover>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    signedIn: state.auth.signedIn,
    validateCouponMessage: state.general.validateCouponMessage,
    validateCouponError: state.general.validateCouponError,
    validateCouponLoading: state.general.validateCouponLoading,
    couponName: state.general.couponName,
  };
};

const mapDispatchToProps = (dispatch) => ({
  couponClearMessage: () => {
    dispatch(couponClearMessage());
  },
  setLoginError: (value) => {
    dispatch(setLoginError(value));
  },
  validateCoupon: (couponCode) => {
    dispatch(validateCoupon(couponCode));
  },
  validateCouponReset: () => {
    dispatch(validateCouponReset());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckCoupon);
